module.exports = __webpack_public_path__ + "static/img/EnglishManual.d35ac25d.png";